import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useConsumerAuth } from '../context/ConsumerAuthContext.jsx';

function Login() {
  const { login } = useConsumerAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    if (!email || !password) {
      setError('Email and password are required');
      return;
    }
    try {
      setSubmitting(true);
      await login({ email, password });
      navigate('/my-impact');
    } catch (err) {
      console.error('Login failed', err);
      setError(err?.message || 'Login failed. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="space-y-6">
      <header className="space-y-2">
        <h1 className="text-3xl font-semibold text-primary">Welcome back</h1>
        <p className="text-sm text-neutral">
          Log in to personalize your Pact experience and save your preferred bins.
        </p>
      </header>
      <form onSubmit={handleSubmit} className="card bg-base-100 shadow-lg">
        <div className="card-body space-y-5">
          <div className="form-control">
            <label className="label" htmlFor="email">
              <span className="label-text uppercase tracking-[0.14em] text-neutral">Email</span>
            </label>
            <input
              id="email"
              type="email"
              className="input input-bordered rounded-xl"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              placeholder="you@example.com"
              required
            />
          </div>
          <div className="form-control">
            <label className="label" htmlFor="password">
              <span className="label-text uppercase tracking-[0.14em] text-neutral">Password</span>
            </label>
            <input
              id="password"
              type="password"
              className="input input-bordered rounded-xl"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              placeholder="••••••••"
              required
            />
          </div>
          {error ? (
            <div className="alert alert-error text-sm">
              <span>{error}</span>
            </div>
          ) : null}
          <button type="submit" className="btn btn-primary w-full rounded-full" disabled={submitting}>
            {submitting ? 'Signing in…' : 'Log in'}
          </button>
          <p className="text-xs text-neutral">
            Don&apos;t have an account yet?{' '}
            <Link to="/signup" className="link link-primary">
              Create one
            </Link>
            .
          </p>
        </div>
      </form>
    </div>
  );
}

export default Login;
